import { Trans, useLingui } from '@lingui/react/macro'
import { PenDisplayActions } from 'features/timeSeries/components/chartActions/PenDisplayActions'
import { PenDrawer } from 'features/timeSeries/components/PenDrawer'
import { usePenVisibilityActions } from 'features/timeSeries/hooks/usePenVisibilityActions'
import { useScatterplotContext } from 'features/timeSeries/ScatterplotContext'
import { WorkbenchPane } from 'features/workbench/WorkbenchPane'
import React from 'react'
import styled from 'styled-components'

const EmptyHint = styled.div`
  padding: 0.5rem;
  font-size: 0.6875rem;
  color: var(--muted-foreground);
`

interface PensPaneProps {
  showDescriptions: boolean
  onToggleDescriptions: () => void
  grow?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

export const PensPane: React.FC<PensPaneProps> = ({
  showDescriptions,
  onToggleDescriptions,
  grow = false,
  open,
  onOpenChange,
}) => {
  const { t } = useLingui()
  const { isLoading, isInitializing } = useScatterplotContext()
  const { allItems } = usePenVisibilityActions()
  const isEmpty = allItems.length === 0 && !isLoading && !isInitializing

  return (
    <WorkbenchPane
      title={t`Selected Tags`}
      count={allItems.length}
      grow={grow}
      open={open}
      onOpenChange={onOpenChange}
      actions={
        <PenDisplayActions
          appearance='pane'
          showDescriptions={showDescriptions}
          onToggleDescriptions={onToggleDescriptions}
        />
      }>
      {isEmpty ? (
        <EmptyHint>
          <Trans>Nothing plotted yet.</Trans>
        </EmptyHint>
      ) : (
        <PenDrawer
          fluid
          hideHeaderActions
          hideTransforms
          showDescriptions={showDescriptions}
        />
      )}
    </WorkbenchPane>
  )
}
